export default __webpack_public_path__ + "static/media/icon_info_category_02.1797bc6c.svg";